import { Pagination } from 'flowbite-react';
import React from 'react'
interface PaginationProps{
    currentPage:number,
    setCurrentPage :(data:number) =>void,
    itemsNumber:number
}
const PaginationComponent = ({currentPage, setCurrentPage, itemsNumber}:PaginationProps) => {

  const onPageChange = (page: number) => setCurrentPage(page);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(itemsNumber/itemsPerPage)
  return (
    <div className="flex overflow-x-auto sm:justify-center">
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
    </div>
  );
}

export default PaginationComponent
